import React from "react";
import { Card, KeyValueList, ValueOrPlaceholder } from "@sscs/ui";
import { transformMaterialType } from "../../utils";
const isoTimeToLocaleString = (isoTime) => isoTime ? new Date(isoTime).toLocaleString() : "";
const CryptoMaterialCard = ({ material, link, }) => {
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { actions: link }, "Material Details"),
        React.createElement(Card.Content, null, React.createElement(KeyValueList, { list: {
                Material: transformMaterialType(material.type),
                "Created on": (React.createElement(ValueOrPlaceholder, { value: isoTimeToLocaleString(material.creation) })),
                "Expires on": (React.createElement(ValueOrPlaceholder, { value: isoTimeToLocaleString(material.expiration) })),
                Size: material.size ? (`${material.size} bits`) : (React.createElement(ValueOrPlaceholder, { value: material.size })),
                ...Object.fromEntries(material.properties),
            } }))));
};
export default CryptoMaterialCard;
//# sourceMappingURL=CryptoMaterialCard.js.map